import React from "react";

// @Mention RENDERING for the lounge (QAL-T4). Mentions are a pure text
// convention (T4 contract §4): the text is stored verbatim, there is no
// picker and no server-side resolution until T8. This module only paints
// `@Word` tokens in link style (600, platform blue — design 1c: the
// `@Tomás` reply) — no popup, no navigation.
//
// Built after the utils/profileLinkDetector pattern (pure tokenizer the
// tests hit directly + a thin render layer) but kept lounge-local on
// purpose: the profile detector matches profile URLs for chat cards,
// which is a different concern.
//
// Token rule: `@` followed by letters/digits/underscore (unicode, so
// `@Tomás` works). The lookbehind stops e-mail addresses from lighting
// up (`name@agency.com` contains no mention).
const MENTION_PATTERN = /(?<![\p{L}\p{N}_])@[\p{L}\p{N}_]+/gu;

// Split text into ordered {type: "text" | "mention", value} parts.
export const splitMentions = (text) => {
  const parts = [];
  if (!text || typeof text !== "string") return parts;
  let last = 0;
  for (const match of text.matchAll(MENTION_PATTERN)) {
    if (match.index > last) {
      parts.push({ type: "text", value: text.slice(last, match.index) });
    }
    parts.push({ type: "mention", value: match[0] });
    last = match.index + match[0].length;
  }
  if (last < text.length) parts.push({ type: "text", value: text.slice(last) });
  return parts;
};

// Render text with mentions in anchor style (600, platform blue). A span —
// not an anchor — because nothing is linked yet (T8).
export const MentionText = ({ text }) => (
  <>
    {splitMentions(text).map((part, i) =>
      part.type === "mention" ? (
        <span key={i} className="font-semibold text-[#2283FF]">
          {part.value}
        </span>
      ) : (
        <React.Fragment key={i}>{part.value}</React.Fragment>
      ),
    )}
  </>
);

export default MentionText;
